import { SearchRequestInstrumentation } from 'owa-search-service';
import { PerformanceDatapoint, CalculatedResourceTimings } from 'owa-analytics';

// Key names for datapoint fields
const RESOURCE_TIMING_ROLLUP = 'cpv'; // name matches JsMVVM
const SEARCH_PROVIDER = 'SearchProvider';
const BE_HTTP_STATUS = 'BeHttpStatus';
const CLIENT_HTTP_STATUS = 'ClientHttpStatus';
const CLIENT_REQUEST_ID = 'ClientRequestID';
const PAGE_NUMBER = 'PageNumber';
const REQUEST_ID = 'RequestId';
const MSEDGE_REF = 'MSEdgeRef';
const DIAGNOSTICS_CHECKPOINTS = 'DiagnosticsCheckpoints';
const CLIENT_NETWORK_TIME = 'ClientNetworkTime';
const CLIENT_JS_PRE_REQUEST_TIME = 'ClientJsPreRequestTime';
const CLIENT_JS_REQUEST_THREAD_TIME = 'ClientJSRequestThreadTime';
const CLIENT_JS_RESPONSE_PROCESS_TIME = 'ClientJsResponseProcessTime';
const CLIENT_JS_RENDERING_TIME = 'ClientJsRenderingTime';

/**
 * Log the aggregate search performance datapoint
 * @param searchRequestInstrumentation - the request instrumentation data
 */
export default function logPerformanceDatapoint(
    searchRequestInstrumentation: SearchRequestInstrumentation
) {
    const perfDatapoint = new PerformanceDatapoint('SearchInstrumentation');

    const data: { [key: string]: any } = {};

    // Resource timing entry may not be logged by certain browsers
    if (searchRequestInstrumentation.ResourceTimingEntry) {
        // Add all PerformanceResourceTiming fields
        const resourceTimingEntry = searchRequestInstrumentation.ResourceTimingEntry;
        Object.keys(resourceTimingEntry).forEach(key => (data[key] = resourceTimingEntry[key]));

        // Add rollup resource timing entries
        data[RESOURCE_TIMING_ROLLUP] = getResourceTimingRollup(resourceTimingEntry);
    }

    // Add selective fields from SearchRequestInstrumentation
    data[SEARCH_PROVIDER] = searchRequestInstrumentation.ClientSearchProvider;
    data[BE_HTTP_STATUS] = searchRequestInstrumentation.SearchBEHttpStatus;
    data[CLIENT_HTTP_STATUS] = searchRequestInstrumentation.ClientHttpStatus;
    data[CLIENT_REQUEST_ID] = searchRequestInstrumentation.SearchClientRequestID;
    data[PAGE_NUMBER] = searchRequestInstrumentation.PageNumber;
    data[REQUEST_ID] = searchRequestInstrumentation.SearchTraceID;
    data[MSEDGE_REF] = searchRequestInstrumentation.SearchMsEdgeRef;
    data[DIAGNOSTICS_CHECKPOINTS] = searchRequestInstrumentation.DiagnosticsCheckpoints;
    data[CLIENT_NETWORK_TIME] = searchRequestInstrumentation.ClientNetworkTime;
    data[CLIENT_JS_PRE_REQUEST_TIME] = searchRequestInstrumentation.ClientJSPreRequestTime;
    data[CLIENT_JS_REQUEST_THREAD_TIME] = searchRequestInstrumentation.ClientJSRequestThreadTime;
    data[CLIENT_JS_RESPONSE_PROCESS_TIME] = searchRequestInstrumentation.ClientResponseProcessTime;
    data[CLIENT_JS_RENDERING_TIME] = searchRequestInstrumentation.ClientJSRenderingTime;

    perfDatapoint.addCustomData(data);
    perfDatapoint.end(searchRequestInstrumentation.ClientJSEndToEndTime);
}

function getResourceTimingRollup(resourceTimingEntry: CalculatedResourceTimings): string {
    const timingEntries = [
        resourceTimingEntry.RdS,
        resourceTimingEntry.RdE,
        resourceTimingEntry.FS,
        resourceTimingEntry.DS,
        resourceTimingEntry.DE,
        resourceTimingEntry.CS,
        resourceTimingEntry.SCS,
        resourceTimingEntry.CE,
        resourceTimingEntry.RqS,
        resourceTimingEntry.RpS,
        resourceTimingEntry.RpE,
    ];

    return timingEntries.join('/') + '/';
}
